import { Toaster as Sonner } from 'sonner';

const dot = (color: string) => <span aria-hidden="true" className="w-2 h-2 rounded-full shrink-0 mt-[5px]" style={{ background: color }} />;

/**
 * Bottom right, one at a time, 6s (8m). A card with a hairline border and a coloured status dot - not an inverted
 * banner. Success auto-dismisses and may carry Undo; errors persist until dismissed and never block the timer.
 */
export function Toaster() {
  return (
    <Sonner position="bottom-right" visibleToasts={1} duration={6000} closeButton gap={10}
      icons={{
        success: dot('var(--color-success-fg)'),
        error: dot('var(--color-danger-fg)'),
        warning: dot('var(--color-warning-fg)'),
        info: dot('var(--color-ink-2)'),
        loading: dot('var(--color-ink-3)'),
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'flex items-start gap-[11px] w-[360px] rounded-[11px] border border-chip-border bg-card px-[15px] py-[13px] shadow-[0_14px_34px_rgba(0,0,0,.18)]',
          error: 'border-danger-fg',
          title: 'text-[12.5px] font-extrabold text-ink',
          description: 'text-[11.5px] font-semibold text-ink-2 mt-[3px]',
          content: 'flex-1 min-w-0',
          // Both buttons are taller than the title's line, and the row aligns to the top so a two-line toast keeps
          // them beside the title. The negative vertical margins centre each on that first line instead of
          // hanging below it, and stop them from stretching a one-line toast.
          actionButton: 'ml-auto shrink-0 -my-[6px] text-[11.5px] font-extrabold text-accent-text border border-chip-border rounded-[7px] px-[10px] py-[6px] bg-transparent cursor-pointer hover:bg-inset',
          // Unstyled toasts get none of sonner's absolute positioning, and the button comes first in its DOM, so
          // without `order-last` the × lands in front of the title. Sized for a fingertip, pulled into the padding.
          closeButton: 'order-last shrink-0 -mr-[7px] -my-[5px] grid place-items-center size-7 rounded-[7px] text-ink-2 border-0 bg-transparent cursor-pointer hover:text-ink hover:bg-inset',
        },
      }} />
  );
}
